import PropTypes from "prop-types";
import React from "react";

import styled from "styled-components/macro";

DesignationLink.propTypes = {
  paymentsEnabled: PropTypes.bool,
  children: PropTypes.object,
  fundID: PropTypes.number,
};

export default function DesignationLink({ paymentsEnabled, children, fundID }) {
  if (paymentsEnabled) {
    return (
      <A href={`/give/${fundID}`} target="_blank" rel="noreferrer">
        {children}
      </A>
    );
  }
  return children;
}

const A = styled.a`
  text-decoration: none !important;
`;
